import { validateConfirmation } from "ember-changeset-validations/validators";
import validatePasswordStrength from "parog-web/validators/password-strength";

export default {
  password: validatePasswordStrength(),

  passwordConfirmation: validateConfirmation({
    on: "password",
    message: "La confirmation du mot de passe ne correspond pas au mot de passe"
  })
};
